import AuthScreen from './AuthScreen';
export default function Login() { return <AuthScreen />; }
